<template>
  <div class="container">
    <div class="row">
      <div class="slopePage__title">
        <b>Крепежный элемент</b>
      </div>
    </div>
    <div class="row">
      <div class="slopePage__info">
        <img src="@/assets/img/info-result.svg" alt="info" class="slopePage__info-img">
        <div class="slopePage__info-text" v-if="isFastenersNeed">
          Подробная информация по крепежному элементу и группировке
          крепежа для каждого участка расчитана на странице участка
        </div>
        <div class="slopePage__info-text" v-else>
          Для выбранных участков расчет крепежей отключен
        </div>
      </div>
    </div>
    <div class="row" v-if="isFastenersNeed">
      <div class="fastener">
        <div class="fastener__head">
          <div class="fastener__head-title">Наименование</div>
          <div class="fastener__head-title">К-во</div>
        </div>
        <div class="fastener__item" v-for="(item, i) in filteredFasteners" :key="i">
          <div class="fastener__item-img"><img :src="item.src" :alt="item.name"></div>
          <div class="fastener__item-title">{{ item.name }}</div>
          <div class="fastener__item-count">{{ item.count }} шт.</div>
        </div>
        <div class="fastener__footer"
             v-if="fasteners.length > 18"
             @click="isShowRemaining = !isShowRemaining"
             :class="{ active: isShowRemaining }">
          <div v-if="!isShowRemaining" class="fastener__footer-count">
            Показать все: {{ fasteners.length }}
          </div>
          <div v-else class="fastener__footer-count">Скрыть</div>
          <div class="fastener__footer-arrow">
            <img src="@/assets/img/select-tick-red.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    pdfStart: Boolean,
    fasteners: Array,
    isFastenersNeed: Boolean,
  },
  data() {
    return {
      isShowRemaining: false,
      /* eslint-disable import/no-unresolved */
      /* eslint-disable global-require */
      /* eslint-enable import/no-unresolved */
      /* eslint-enable global-require */
    };
  },
  components: {
  },
  methods: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    sortedFasteners() {
      return this.fasteners.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        let comparison = 0;
        if (nameA > nameB) {
          comparison = -1;
        } else if (nameA < nameB) {
          comparison = 1;
        }
        return comparison;
      });
    },
    filteredFasteners() {
      return this.isShowRemaining ? this.fasteners : this.fasteners.slice(0, 18);
    },
  },
};
</script>

<style lang="sass" scoped>
.fastener
  width: 100%
  color: $black
  &__head
    display: grid
    @extend .common__result-header
    +media((grid-template-columns: (320: 4fr 7fr 3fr, 768: 2fr 8fr 2fr)))
    &-title
      padding: rem(25) 0
      text-align: left
      @extend .common__title-result
      &:first-of-type
        grid-column-start: 2
      &:last-of-type
        +media((padding-left: (320: 0, 768: rem(40))))
  &__item
    display: grid
    +media((grid-template-columns: (320: 4fr 7fr 3fr, 768: 2fr 8fr 2fr)))
    background: #fff
    padding-top: rem(2)
    padding-bottom: rem(2)
    margin-bottom: rem(1)
    &-title, &-count
      font-style: normal
      font-weight: 500
      font-size: rem(14)
      line-height: rem(30)
      text-align: left
      display: flex
      flex-direction: row
      align-items: center
    &-count
      +media((padding-left: (320: 0, 768: rem(40))))
    &-img
      display: flex
      flex-direction: column
      justify-content: center
      +media((padding-left: (320: rem(24), 768: rem(40))))
      align-items: flex-start
      img
        max-width: rem(69)
  &__footer
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    cursor: pointer
    @extend .common__result-footer
    &-count
      @extend .common__result-footer--count
    &-arrow
      @extend .common__result-footer--arrow
    &.active
      .fastener__footer-arrow
        img
          transform: rotate(180deg)
</style>
